import { ChangeDetectionStrategy, Component, OnInit, inject } from '@angular/core';
import { Router } from '@angular/router';
import { UserConfigurationService } from '../../core/services/user-configuration.service';

@Component({
  selector: 'osp-app-home-redirect',
  template: '<div>Redirecting...</div>',
  standalone: true,
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class HomeRedirectComponent implements OnInit {
  private userConfigurationService = inject(UserConfigurationService);
  private router = inject(Router);

  ngOnInit(): void {
    const homepage = this.userConfigurationService.getSetting('homepage') || '/resources/equipment/list';
    this.router.navigateByUrl(homepage);
  }
}
